import React, { useEffect } from 'react';
import { BrowserRouter, useNavigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './runrora-branding.css';
import { AuthProvider, useAuth } from './AuthContext';
import CommunityBrowser from './CommunityBrowser';

// Redirect old hash URLs (/#/race/42) to real paths (/race/42)
const HashRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.hash && location.hash.startsWith('#/')) {
      const newPath = location.hash.slice(1); // remove '#'
      navigate(newPath, { replace: true });
    }
  }, [location.hash, navigate]);
  return null;
};

const AppContent = () => {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#0B0B10',
        color: '#FFFFFF'
      }}>
        <h2>Loading...</h2>
      </div>
    );
  }

  return (
    <>
      <HashRedirect />
      {/* Alpha Banner */}
      <div style={{
        background: 'linear-gradient(135deg, #FF8A3D 0%, #C23AFF 100%)',
        color: '#0B0B10',
        textAlign: 'center',
        padding: '0.6rem 1rem',
        fontSize: '0.85rem',
        fontWeight: 500,
        zIndex: 200,
        position: 'relative'
      }}>
        You're previewing an early version of Runrora. Your feedback shapes what we build.
      </div>

      <CommunityBrowser user={user} onLogout={logout} />

      {/* Floating Feedback Button */}
      <a
        href="https://tally.so/r/dWxE9D"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '1.5rem',
          right: '1.5rem',
          background: '#FF8A3D',
          color: '#0B0B10',
          padding: '0.75rem 1.25rem',
          borderRadius: '25px',
          fontSize: '0.9rem',
          fontWeight: 600,
          textDecoration: 'none',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
          zIndex: 1000,
          transition: 'all 0.2s ease'
        }}
      >
        Share Feedback
      </a>
    </>
  );
};

const App = () => (
  <BrowserRouter>
    <HelmetProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </HelmetProvider>
  </BrowserRouter>
);

export default App;
